import { useContext, useEffect } from "react";
import { AppContext } from "../../contexts/AppContext";
import { InfoBanner, InfoHeaderIcon } from "../components/Shared/InfoBanner";
import { RouteContext } from "../../contexts/RoutesContext";
import { Colour } from "../Variables";
import { RegisterForm } from "../components/Forms/RegisterForm";

export function Register() {
    const app = useContext(AppContext);

    const routeContext = useContext(RouteContext);
    useEffect(() => {
        routeContext.setRoutes([{ name: "Register", route: null }])
    }, []);

    return (
        <>
            <InfoBanner
                header="Register"
                narrow={false}
                icon={InfoHeaderIcon.Register}
                info={""}
                subHeader={`${app.firmName} online application system`}
                theme={Colour.Primary}>
                <p dangerouslySetInnerHTML={{ __html: app.baseFeatures.PrivacyPolicyText }}></p>
                <div dangerouslySetInnerHTML={{ __html: app.baseFeatures.CompanyPrivacyPolicyText }}></div>
            </InfoBanner>
            
            {app.redesign_BannerVer != "-1" && <img src={`/app/StyleBundle/banner?v=${app.redesign_BannerVer}`} className={`d-block w-100 mb-3 ${app.redesign_BannerOnly ? "mt-3" : ""}`} alt="Firm banner image" />}

            <RegisterForm />
        </>
    );
}